import * as fromStats from '../actions/stats.action';
import {AccountType} from '../../../users/account-type';


export interface StatsState {
  data: any;
  hoursLoading: boolean;
  loaded: Boolean;
  loading: Boolean;
  error: string;
};

export const initialState = {
  data: null,
  loaded: false,
  loading: false,
  hoursLoading: false,
  error: null
};

export function reducer(state = initialState, action: fromStats.StatsActions): StatsState {
  switch (action.type) {
    case fromStats.GET_STATS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromStats.GET_STATS_SUCCESS: {
      const data = action.payload[0];
      let response = {};
      if (!!data) {
        response = {
          loggedInToday: !!data.loggedInToday ? data.loggedInToday.filter(user => user.accountType === AccountType.FREELANCER) : [],
          updatedToday: !!data.updatedToday ? data.updatedToday.filter(user => user.accountType === AccountType.FREELANCER) : [],
          clockedInToday: !!data.clockedInToday ? data.clockedInToday.filter(user => user.accountType === AccountType.FREELANCER) : [],
          clockedOutToday: !!data.clockedOutToday ? data.clockedOutToday.filter(user => user.accountType === AccountType.FREELANCER) : [],
        };
      }
      return {
        ...state,
        loading: false,
        loaded: true,
        data: response,
        error: null,
      };
    }
    case fromStats.GET_STATS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        data: null,
        error: action.payload
      };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/store/reducers/stats.reducer.ts